import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import { setLocalizationLangCd } from '../util';

export function initI18n({ loadPath, responseParser = (data) => JSON.parse(data), language }) {
  setLocalizationLangCd(language);
  return i18next
    .use(Backend)
    .use(initReactI18next)
    .init({
      fallbackLng: 'en',
      debug: true,
      interpolation: {
        escapeValue: false,
      },
      backend: {
        loadPath: `${import.meta.env.VITE_PUBLIC_URL}${loadPath}`,
        parse: responseParser,
        queryStringParams: { b: window.CACHE_BUSTER },
      },
      lng: language,
    });
}

export default i18next;
